// OK 04/11/2024

import {  FileInvoiceCar, VehiculeHistory } from "../interfaces";
import { ObjectId } from "../types";
import { ip } from "../utils/setup";

const VEHICULE_HISTORY_API = `${ip}/api/VehiculeHistories`;

// GET

// GET ID

export async function getVehiculeHistoriesByCar(
  _id: ObjectId
): Promise<VehiculeHistory[]> {
  const response = await fetch(`${VEHICULE_HISTORY_API}/${_id}/byCar`, {
    credentials: "include",
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      "Erreur du serveur lors de la reception de l'historique des entretiens du v�hicule"
    );
  }
}

export async function getVehiculeHistories(
  _id: ObjectId
): Promise<VehiculeHistory[]> {
  const response = await fetch(`${VEHICULE_HISTORY_API}/${_id}`, {
    credentials: "include",
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      "Erreur du serveur lors de la reception de l'historique des entretiens du v�hicule"
    );
  }
}

export async function getfilesInvoiceCar(
    _id: ObjectId
): Promise<FileInvoiceCar> {
    const response = await fetch(`${VEHICULE_HISTORY_API}/${_id}/getInvoice`, {
        credentials: "include"
    });
    if (response.ok) {
        return response.json();
    } else {
        throw new Error("Erreur du serveur lors de la réception de la facture");
    }
}

// POST

export async function createVehiculeHistory(
  newVehiculeHistory: Partial<VehiculeHistory>
): Promise<VehiculeHistory> {
  const formData = new FormData();
  Object.entries(newVehiculeHistory).forEach(([key, value]) => {
    if (key !== "facture") {
      formData.append(key, value as string);
    }
    if (
      newVehiculeHistory.facture instanceof FileList &&
      newVehiculeHistory.facture.length > 0
    ) {
      formData.append("facture", newVehiculeHistory.facture[0]);
    } else {
      formData.append("facture", "" as string);
    }
  });

  const response = await fetch(VEHICULE_HISTORY_API, {
    method: "POST",
    credentials: "include",
    //   headers: {
    //       "content-type": "application/json",

    //   },
    body: formData,
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      " Erreur lors de la création du nouvel historique de véhicule"
    );
  }
}

//PUT

export async function updateVehiculeHistory(
  updateVehiculeHistory: VehiculeHistory
) {
  const formData = new FormData();
  Object.entries(updateVehiculeHistory).forEach(([key, value]) => {
    if (key !== "facture") {
      formData.append(key, value as string);
    }
    if (
      updateVehiculeHistory.facture instanceof FileList &&
      updateVehiculeHistory.facture.length > 0
    ) {
      formData.append("facture", updateVehiculeHistory.facture[0]);
    } else {
      formData.append("facture", "" as string);
    }
  });
  const response = await fetch(
    `${VEHICULE_HISTORY_API}/${updateVehiculeHistory.idVehiculeHistory}`,
    {
      method: "PUT",
      credentials: "include",

      body: formData,
    }
  );
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition de l'entretien véhicule");
  }
}

export async function deleteVehiculeHistory(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${VEHICULE_HISTORY_API}/${_id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error(
      "Erreur lors de la suppression de l'historique du v�hicule "
    );
  }
}
